import classnames from 'classnames';
import styles from './Title.module.less';
export var useTitleStyles = function useTitleStyles(_ref) {
  var size = _ref.size;
  return {
    className: classnames([size !== undefined && styles["title-".concat(size)]])
  };
};